import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const FlightPricedRecommendationTypeIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", {
    width: "60",
    height: "62",
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, __jsx("g", {
    filter: "url(#filter0_dd_25836_214590)"
  }, __jsx("path", {
    d: "M8 15.9631C8 14.2417 9.25183 12.7758 10.9521 12.5063L47.9521 6.64161C50.0771 6.30479 52 7.94693 52 10.0985V41.9677C52 43.687 50.7513 45.1517 49.0536 45.4236L12.0536 51.3507C9.92687 51.6913 8 50.0486 8 47.8947V15.9631Z",
    fill: "#05BC50"
  }), __jsx("g", {
    "clip-path": "url(#clip0_25836_214590)"
  }, __jsx("path", {
    d: "M26.404 28.9966C26.3272 28.9966 26.2504 28.9711 26.1873 28.9183L18.8209 22.8602C18.3824 22.4977 18.1128 21.9632 18.0838 21.3963C18.0548 20.8295 18.2647 20.2695 18.6605 19.8627L18.9216 19.5954C19.4728 19.032 20.3089 18.8329 21.0545 19.0882L32.0469 22.8619C32.1578 22.9011 32.2414 22.993 32.2687 23.1087C32.296 23.2245 32.2602 23.3436 32.1766 23.427L26.6446 28.8979C26.578 28.9626 26.491 28.9966 26.404 28.9966ZM20.3908 19.6601C20.0273 19.6601 19.6707 19.8048 19.4096 20.0721L19.1486 20.3393C18.8807 20.6151 18.7424 20.9776 18.7629 21.3606C18.7834 21.7436 18.9574 22.0908 19.2543 22.336L26.3818 28.1966L31.3046 23.3283L20.831 19.7333C20.6894 19.6839 20.5392 19.6601 20.3908 19.6601Z",
    fill: "white",
    stroke: "white",
    "stroke-width": "0.5"
  }), __jsx("path", {
    d: "M37.4343 41.0008C37.3865 41.0008 37.3387 40.9991 37.2926 40.9957C36.7244 40.9565 36.1954 40.6791 35.8388 40.2365L29.8922 32.7844C29.7847 32.6499 29.7949 32.4541 29.9178 32.3316L35.3781 26.8846C35.4617 26.8012 35.5829 26.7671 35.6972 26.7944C35.8115 26.8216 35.9054 26.9067 35.9429 27.0174L39.6542 38.0679C39.6542 38.0696 39.6542 38.0696 39.6559 38.0713C39.8999 38.8203 39.6867 39.651 39.1116 40.1906L38.8386 40.4459C38.4581 40.8016 37.953 41.0008 37.4343 41.0008ZM30.6157 32.5971L36.3712 39.811C36.6118 40.1088 36.9548 40.2893 37.3404 40.3165C37.726 40.3437 38.0912 40.2127 38.3711 39.9505L38.6441 39.6952C39.0263 39.336 39.1696 38.7811 39.0075 38.2841L35.4702 27.7561L30.6157 32.5971Z",
    fill: "white",
    stroke: "white",
    "stroke-width": "0.5"
  }), __jsx("path", {
    d: "M20.278 34.9343C19.7951 34.4594 19.3873 34.0577 19.116 33.782L18.7372 33.4092C18.7013 33.3734 18.6808 33.3258 18.6808 33.2747C18.6808 33.2236 18.6996 33.176 18.7354 33.1402L19.4351 32.4338C19.8343 32.3657 21.4656 32.5581 22.1669 32.7113C22.2471 32.633 22.3239 32.5581 22.3956 32.4866L22.7198 32.1717C22.515 32.0849 22.0594 31.964 20.9861 31.8398C19.2661 31.6389 19.1057 31.8006 18.9999 31.9061L18.2508 32.6619C18.087 32.827 17.9983 33.0466 18 33.2798C18.0017 33.513 18.0939 33.7309 18.2594 33.8943L18.6348 34.2637C18.9385 34.5718 19.4129 35.0399 19.9743 35.5897C20.0511 35.3667 20.1551 35.1471 20.278 34.9343Z",
    fill: "white",
    stroke: "white",
    "stroke-width": "0.5"
  }), __jsx("path", {
    d: "M26.7184 36.0256L26.7064 36.0137L26.3191 36.4001C26.2867 36.4324 26.2526 36.4665 26.2184 36.5005C26.3925 36.9277 26.6518 39.0418 26.5853 39.4759L25.8857 40.1823C25.8123 40.2555 25.6895 40.2572 25.6161 40.184L23.7459 38.3423C23.5207 38.4546 23.292 38.5516 23.0634 38.6282L25.1349 40.6691C25.3055 40.836 25.5273 40.9194 25.7492 40.9194C25.9744 40.9194 26.1997 40.8326 26.3703 40.6606L27.1194 39.9049C27.2252 39.7976 27.3839 39.6376 27.1723 37.9235C26.9658 36.269 26.7798 36.0869 26.7184 36.0256Z",
    fill: "white",
    stroke: "white",
    "stroke-width": "0.5"
  }), __jsx("path", {
    d: "M22.0819 39.1356C21.5171 39.1356 20.9694 38.9586 20.4865 38.5144C19.8278 37.9101 19.4866 37.2275 19.4746 36.4854C19.449 34.8989 20.925 33.4504 21.9011 32.492C21.9898 32.4052 22.0751 32.3218 22.1536 32.2435L36.9545 17.8465C38.1422 16.6924 39.6745 16.8541 40.6676 17.5247C41.6726 18.2039 42.3995 19.581 41.7579 21.1249C41.589 21.5334 41.3825 21.8619 41.1437 22.1036L41.1419 22.1053L26.5594 36.6386C25.8666 37.3331 23.8838 39.1356 22.0819 39.1356ZM38.9698 17.6779C38.463 17.6779 37.922 17.8584 37.4306 18.335L37.3965 18.3673L22.6314 32.7269C22.5546 32.8035 22.4693 32.8886 22.3771 32.9772C21.483 33.8538 20.1333 35.1781 20.1537 36.4734C20.1623 37.0283 20.4216 37.5322 20.9455 38.0122C22.5256 39.4625 25.2711 36.9586 26.0748 36.1568L40.6573 21.6236C40.8331 21.4449 40.9901 21.1895 41.1249 20.8644C41.6522 19.5912 41.0003 18.5733 40.2819 18.0882C39.9339 17.8533 39.4697 17.6779 38.9698 17.6779Z",
    fill: "white"
  }), __jsx("path", {
    d: "M40.9031 21.867H40.9048M22.0819 39.1356C21.5171 39.1356 20.9694 38.9586 20.4865 38.5144C19.8278 37.9101 19.4866 37.2275 19.4746 36.4854C19.449 34.8989 20.925 33.4504 21.9011 32.492C21.9898 32.4052 22.0751 32.3218 22.1536 32.2435L36.9545 17.8465C38.1422 16.6924 39.6745 16.8541 40.6676 17.5247C41.6726 18.2039 42.3995 19.581 41.7579 21.1249C41.589 21.5334 41.3825 21.8619 41.1437 22.1036L41.1419 22.1053L26.5594 36.6386C25.8666 37.3331 23.8838 39.1356 22.0819 39.1356ZM38.9698 17.6779C38.463 17.6779 37.922 17.8584 37.4306 18.335L37.3965 18.3673L22.6314 32.7269C22.5546 32.8035 22.4693 32.8887 22.3771 32.9772C21.483 33.8538 20.1333 35.1781 20.1537 36.4734C20.1623 37.0283 20.4216 37.5322 20.9455 38.0122C22.5256 39.4625 25.2711 36.9586 26.0748 36.1568L40.6573 21.6236C40.8331 21.4449 40.9901 21.1895 41.1249 20.8644C41.6522 19.5912 41.0003 18.5733 40.2819 18.0882C39.9339 17.8533 39.4697 17.6779 38.9698 17.6779Z",
    stroke: "white",
    "stroke-width": "0.5"
  }), __jsx("path", {
    d: "M22.7462 20.0285C22.7906 19.6472 23.1216 19.3391 23.5124 19.3391C23.9321 19.3391 24.2871 19.6931 24.2871 20.1119C24.2871 20.26 24.241 20.3978 24.1659 20.5153L24.8229 20.7417C24.915 20.551 24.9679 20.3383 24.9679 20.1119C24.9679 19.3101 24.3144 18.6582 23.5107 18.6582C22.8128 18.6582 22.2292 19.1501 22.0876 19.8038L22.7462 20.0285Z",
    fill: "white",
    stroke: "white",
    "stroke-width": "0.5"
  }), __jsx("path", {
    d: "M26.1995 21.2141C26.2558 20.8464 26.5817 20.5537 26.9622 20.5537C27.382 20.5537 27.7369 20.9077 27.7369 21.3265C27.7369 21.4643 27.696 21.592 27.6311 21.7043L28.2864 21.929C28.3717 21.7452 28.4195 21.5409 28.4195 21.3248C28.4195 20.523 27.7659 19.8711 26.9622 19.8711C26.2746 19.8711 25.6995 20.3477 25.5459 20.9877L26.1995 21.2141Z",
    fill: "white",
    stroke: "white",
    "stroke-width": "0.5"
  }), __jsx("path", {
    d: "M36.9195 30.9963C37.0407 30.918 37.184 30.8703 37.3359 30.8703C37.7556 30.8703 38.1105 31.2244 38.1105 31.6431C38.1105 32.0499 37.7932 32.3802 37.3939 32.4108L37.6157 33.0695C38.2863 32.9385 38.7931 32.3495 38.7931 31.6431C38.7931 30.8414 38.1396 30.1895 37.3359 30.1895C37.1072 30.1895 36.8922 30.2439 36.6977 30.3376L36.9195 30.9963Z",
    fill: "white",
    stroke: "white",
    "stroke-width": "0.5"
  }), __jsx("path", {
    d: "M38.553 33.6309C38.3039 33.6309 38.0684 33.6938 37.8619 33.8045L38.0871 34.4751C38.2185 34.3747 38.3789 34.3117 38.553 34.3117C38.9727 34.3117 39.3277 34.6658 39.3277 35.0845C39.3277 35.5033 38.9727 35.8573 38.553 35.8573L38.7748 36.5195C39.4727 36.4122 40.0102 35.8097 40.0102 35.0845C40.0119 34.2845 39.3567 33.6309 38.553 33.6309Z",
    fill: "white",
    stroke: "white",
    "stroke-width": "0.5"
  }))), __jsx("defs", null, __jsx("filter", {
    id: "filter0_dd_25836_214590",
    x: "0",
    y: "0.597656",
    width: "60.4307",
    height: "60.834",
    filterUnits: "userSpaceOnUse",
    "color-interpolation-filters": "sRGB"
  }, __jsx("feFlood", {
    "flood-opacity": "0",
    result: "BackgroundImageFix"
  }), __jsx("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), __jsx("feOffset", {
    dy: "2"
  }), __jsx("feGaussianBlur", {
    stdDeviation: "4"
  }), __jsx("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), __jsx("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.15 0 0 0 0 0.302069 0 0 0 0 0.5 0 0 0 0.15 0"
  }), __jsx("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_25836_214590"
  }), __jsx("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), __jsx("feOffset", {
    dy: "3.39"
  }), __jsx("feGaussianBlur", {
    stdDeviation: "2.26"
  }), __jsx("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), __jsx("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.113725 0 0 0 0 0.294118 0 0 0 0.3 0"
  }), __jsx("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_25836_214590",
    result: "effect2_dropShadow_25836_214590"
  }), __jsx("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_25836_214590",
    result: "shape"
  })), __jsx("clipPath", {
    id: "clip0_25836_214590"
  }, __jsx("rect", {
    width: "26",
    height: "26",
    fill: "white",
    transform: "translate(17 16)"
  }))));
};
export default FlightPricedRecommendationTypeIcon;